import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'

import type { KyrgyzstanMapRouteState } from 'entities/kyrgyzstan/lib'

import { HeaderGoBack } from 'shared/ui/header-go-back'
import { LayoutMap, ZoomControls } from 'shared/ui/map/components'
import { useMap } from 'shared/ui/map/libs'

import s from './styles.module.scss'

const KyrgyzstanMapPage = () => {
  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()
  const { state } = useLocation()

  const map = (state as KyrgyzstanMapRouteState | null)?.map
  const data = map?.realtyId === id ? map : null

  const center = {
    latitude: data?.latitude ?? 0,
    longitude: data?.longitude ?? 0,
  }

  const markers = data
    ? [
        {
          latitude: data.latitude,
          longitude: data.longitude,
          title: data.title,
        },
      ]
    : []

  const {
    isMapLoading,
    mapError,
    mapRef,
    handleZoomIn,
    handleZoomOut,
    handleRetry,
  } = useMap({
    center,
    markers,
    errorMessage: 'kyrgyzstan_block.detail.map_error',
  })

  if (!data) {
    return (
      <div className="container">
        <HeaderGoBack
          buttonWhite
          variant="grey"
          title=""
        />
        <div className={s.error}>
          <p>{t('kyrgyzstan_block.error.title')}</p>
        </div>
      </div>
    )
  }

  return (
    <LayoutMap
      title={data.address || ''}
      isMapLoading={isMapLoading}
      mapError={mapError}
      handleRetry={handleRetry}
      map={
        <div
          className={s.map}
          ref={mapRef}
        />
      }
      zoomControls={
        <ZoomControls
          handleZoomIn={handleZoomIn}
          handleZoomOut={handleZoomOut}
        />
      }
    />
  )
}

export default KyrgyzstanMapPage
